import React from "react";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { useBilling } from "@/contexts/BillingContext";
import { Trans, useTranslation } from "react-i18next";

// Follow-ups and summary actions are not part of the free trial.
export function PaidOnlyNote({ testid }) {
  const { billing } = useBilling();
  const { t } = useTranslation();
  const anon = !!billing?.is_anonymous;
  return (
    <div className="mb-4 border border-[#002FA7] bg-[#002FA7]/5 p-3 text-[13px] flex flex-wrap items-center gap-3" data-testid={testid}>
      <Lock className="w-4 h-4 text-[#002FA7] shrink-0" />
      <span className="flex-1 min-w-[200px]">
        <Trans i18nKey="trial.paid_only" components={{ b: <b /> }} />
      </span>
      <Link
        to={anon ? "/signup" : "/billing/upgrade"}
        data-testid={`${testid}-cta`}
        className="font-mono uppercase tracking-[0.14em] text-[11px] px-3 py-2 bg-[#002FA7] text-white hover:bg-[#001a66] transition-colors"
      >
        {anon ? t("trial.create_account") : t("trial.see_packs")}
      </Link>
    </div>
  );
}

export default PaidOnlyNote;
